const ApiConfig = {
    guidUrl: 'b644a195-60b9-4ae5-b7a9-631d8d37916d'
}


export default ApiConfig;